import React, { ReactNode } from 'react'

import useIsMobile from '@hooks/useIsMobile'

import {
  Container,
  ReservationDateItem,
  ReservationRowItem,
  ReservationSelectableRow,
  ReservationSystemGrid,
} from '../reservationGrid.styled'

type ReservationGridLayoutProps = {
  children: ReactNode
  forceDesktopLayout?: boolean
}

export const ReservationGridLayout = ({
  children,
  forceDesktopLayout,
}: ReservationGridLayoutProps) => (
  <Container style={{ margin: forceDesktopLayout ? '30px 0' : '50px' }}>
    <ReservationSystemGrid forceDesktopLayout={forceDesktopLayout}>
      {children}
    </ReservationSystemGrid>
  </Container>
)

type ReservationGridLayoutRowProps = {
  children: ReactNode
  label: ReactNode
  selected?: boolean
  forceDesktopLayout?: boolean
}

export const ReservationGridLayoutRow = ({
  children,
  label,
  selected = false,
  forceDesktopLayout,
}: ReservationGridLayoutRowProps) => {
  const isMobile = useIsMobile()

  return (
    <ReservationRowItem forceDesktopLayout={forceDesktopLayout}>
      <ReservationDateItem
        forceDesktopLayout={forceDesktopLayout}
        selected={selected}
        isWeekend={false}
        onClick={() => undefined}
        hoverable={isMobile}
      >
        {label}
      </ReservationDateItem>
      <ReservationSelectableRow forceDesktopLayout={forceDesktopLayout}>
        {children}
      </ReservationSelectableRow>
    </ReservationRowItem>
  )
}
